import { loadRemote } from '@module-federation/runtime';
import { useEffect, useState } from 'react';
import type { UseRemoteComponentResult } from './types';
import type { ComponentType } from 'react';

export function useRemoteComponent<T>(remote: string, component: string): UseRemoteComponentResult<T> {
  const [Component, setComponent] = useState<ComponentType<T> | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadComponent(): Promise<void> {
      try {
        setLoading(true);
        const target = await loadRemote(remote) as Record<string, ComponentType<T>>;
        if (target[component] != null) {
          setComponent(() => target[component]);
        }
      } finally {
        setLoading(false);
      }
    }

    loadComponent();
  }, [component, remote]);


  return { Component, loading };
}
